export const buildAuditLogPayload = (payload, entity = 'RoleMaster') => {
  if (entity === 'UserMaster') {
    return {
      UserID: payload.UserID,
      UserName: payload.UserName,
      UserType: payload.UserType,
      Role: payload.Role,
      Division: payload.Division,
      Location: payload.Location,
      BPCode: payload.BPCode,
      EmailID: payload.EmailID,
      MobileNumber: payload.MobileNumber,
      Status: payload.Status,
      Entity: entity,
      CreatedBy: payload.CreatedBy,
      CreatedOn: payload.CreatedOn,
      ModifiedBy: payload.ModifiedBy || payload.CreatedBy,
      ModifiedOn: payload.ModifiedOn || payload.CreatedOn,
      IsDeleted: false
    };
  }
  return {
    RoleCode: payload.RoleCode,
    RoleDescription: payload.RoleDescription,
    Status: payload.Status,
    SessionAccess: payload.SessionAccess,
    Entity: entity,
    CreatedBy: payload.CreatedBy,
    CreatedOn: payload.CreatedOn,
    ModifiedBy: payload.ModifiedBy || payload.CreatedBy,
    ModifiedOn: payload.ModifiedOn || payload.CreatedOn,
    IsDeleted: false
  };
};
